import React, { useMemo } from "react";

import { useQuery } from "@apollo/client";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Divider, Fab } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { graphql } from "@/gql";

import Question from "./components/Question";

const clientModulePageQuery = graphql(`
  query ClientModulePage($answerId: ID!) {
    learningModuleAnswer(id: $answerId) {
      id
      responses
      files {
        id
        signedId
        url
      }
      learningModule {
        id
        title
        sections {
          id
          content
        }
      }
    }
  }
`);

const useStyles = makeStyles()({
  back: {
    border: "1.5px solid #D4DBE5",
    backgroundColor: "white",
  },
  divider: {
    borderBottomWidth: 5,
    borderColor: "#F5F7FA",
    margin: "8px 0",
  },
});

const ClientModulePage: React.FC = () => {
  const { classes } = useStyles();
  const { answerId, clientId } = useParams();
  const { data } = useQuery(clientModulePageQuery, {
    variables: { answerId: answerId ?? "" },
  });
  const answer = data?.learningModuleAnswer;

  const blocks = useMemo(() => {
    return (
      answer?.learningModule.sections.flatMap((s) => s.content.blocks) ?? []
    );
  }, [data]);
  const questionAndAnswers = useMemo(() => {
    const pairs = [];
    for (const response of (answer?.responses as any[]) ?? []) {
      const _response = { ...response };
      const question = blocks.find((b) => b.id === response.questionId);
      if (!question) continue;

      if (question.type === "photoUpload") {
        _response.files = answer?.files
          .filter((f) => response.data.includes(f.signedId))
          .map((f) => f.url);
      }

      pairs.push([_response, question]);
    }
    return pairs;
  }, [data]);

  return (
    <Box p="24px" mx="10px" bgcolor="white">
      <Box display="flex" alignItems="center" gap="16px" py="16px">
        <Fab
          className={classes.back}
          component={Link}
          to={`/clients/${clientId}/modules`}
          size="small"
        >
          <ArrowBackIcon htmlColor="#7D8797" />
        </Fab>
        <Box fontSize={28} fontWeight="700" color="#112340">
          {data?.learningModuleAnswer?.learningModule.title}
        </Box>
      </Box>
      <Divider className={classes.divider} />
      <Box display="flex" flexDirection="column" gap="8px">
        {questionAndAnswers.map(([response, question]) => (
          <Box key={response.questionId} py="16px" px="12px">
            <Question question={question} response={response} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ClientModulePage;
